/**
 * Blocks Panel Plugin
 *
 * Registers the blocks (Hero Cards) visualization as a side-panel plugin.
 * Exposes the plugin contract required by the panel registry.
 */

import { registerPanel } from '../registry.js';
import { mountBlocksView } from './blocksView.js';
import { IconBlocks } from '../../components/Icons.js';

registerPanel({
  type: 'blocks',

  icon: IconBlocks,

  label: (t) => t('blocks_available'),

  /**
   * Mounts the blocks feed visualization into the given container element.
   * Returns the lifecycle handle with destroy() and update() methods.
   *
   * @param {HTMLElement} container - The DOM element to render the feed into.
   * @param {Object} data - Blocks data payload from the API.
   * @param {Object} ctx - Context object with `t` (i18n) and `config`.
   * @returns {{ destroy: Function, update: Function }}
   */
  mount(container, data, ctx) {
    return mountBlocksView(container, data, ctx);
  }
});
